module.exports = __webpack_public_path__ + "static/media/swiss-croatian-collaboration-logo.657b3707.svg";